

































import Vue from 'vue'
import Component from 'vue-class-component'
import TableBasedView from "@/components/TableBasedView.vue"
import {UtmMedium} from "@/Models"
import Rules from "@/Rules"

@Component({
  components: {TableBasedView}
})
export default class UtmMedia extends Vue {

  headers = [
    {text: 'Name', align: 'start', sortable: true, value: 'name', width: '100%'},
    {text: 'Actions', align: 'center', value: 'actions', sortable: false}
  ]

  defaultItem = new UtmMedium()
  rules = new Rules()

}
